import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { IMessage, IRoomDetails } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
declare var require: any
const fileSaver = require('file-saver');

@Component({
  selector: 'app-chat-messages',
  templateUrl: './chat-messages.component.html',
  styleUrls: ['./chat-messages.component.scss']
})
export class ChatMessagesComponent implements OnInit, AfterViewInit {

  @ViewChild('scrollMe') private content: ElementRef;
  roomDetails: IRoomDetails;
  message: string = '';
  userId: any;
  messages: IMessage[];
  LIMIT: number = 15;
  inputBox: boolean = false;
  fileUploaded: any;
  @ViewChild('inputField') inputField: ElementRef;
  generate: boolean = false;
  MAX_FILE_SIZE: number = 10485760;
  @Output() close = new EventEmitter;

  constructor(private chatService: ChatService,
    private authService: AuthService,
    private snackBarService: SnackbarService) {
    this.userId = this.authService.getUserID();
   }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
  }

  sendMessage(){
    if(this.fileUploaded)
    {
      this.chatService.uploadFile(this.fileUploaded, this.roomDetails.roomId);
    }
    else if(this.message.length){
      this.chatService.sendMessage(this.message, this.roomDetails.roomId);
    }
    this.reset();
  }

  getMessages(roomId: string, chatLength: number){
    this.chatService.getMessage(roomId, chatLength).subscribe((res: IMessage[])=>{
      res.forEach(message =>{
        let date = new Date(message.timestamp);
        message.dateConverted = String(date.getDate()) + '-' + String(date.getMonth() + 1) + '-' + String(date.getFullYear());
      });
      this.messages = res;
      this.scrollBottom();
    });
  }

  scrollBottom(){
    try {
      this.content.nativeElement.scrollTop = this.content.nativeElement.scrollHeight + 300;
    } catch (err) {}
  }

  loadMoreChats(){
    this.getMessages(this.roomDetails.roomId, this.messages.length + this.LIMIT)
  }

  uploadFile(event: any){
    let size = event.target.files[0].size;
    if(size < this.MAX_FILE_SIZE)
    {
      this.message = event.target.files[0].name;
      this.fileUploaded = event;
      this.inputBox = true;
    }
    else{
      this.snackBarService.openSnackBar('File Size is too huge !', null, 'top');
      console.log('File Size is too huge !');
    }
    this.inputField.nativeElement.value = "";
  }

  reset(){
    this.inputBox = false;
    this.message = '';
    this.fileUploaded = undefined;
  }

  downloadAttachment(message: IMessage){
    const url = message.fileUrl;
    const name = message.message;
    fileSaver.saveAs(url, name);
  }

  generatePDF(){
    this.generate = true;
    this.chatService.getAllMessages(this.roomDetails.roomId).subscribe((res: IMessage[])=>{
      res.forEach(message =>{
        let date = new Date(message.timestamp);
        message.dateConverted = String(date.getDate()) + '-' + String(date.getMonth() + 1) + '-' + String(date.getFullYear());
      });
      this.messages = res;
      this.scrollBottom();
      if(this.generate)
      {
        this.chatService.generatePDF(this.messages, this.roomDetails);
        this.generate = false;
      }
    });
  }

  closeChat(){
    this.close.emit();
  }
}
